export const isValidCurrencyInput = (input: string): boolean => {
  // eslint-disable-next-line prettier/prettier
  const regex = /^\d+([,.]\d{1,2})?$/;

  return !input || regex.test(input);
};
